import HeroBanner from '../components/HeroBanner';
import HeroBannerWide from '../components/HeroBannerWide';


export default [
    HeroBanner.blockKey,
    HeroBannerWide.blockKey,
];

